<template>
    <div class="edit-pages-feedbacks-form">
        <b-form @submit.stop.prevent="onSubmit" novalidate>
            <div class="content">
                <div class="feedback" v-for="(feedback, index) in form.feedbacks" :key="index">
                    <div class="edit" @click="openFeedbackModal(true, feedback)">Editar</div>

                    <div class="delete" @click="deleteFeedback(feedback.id)">Excluir</div>

                    <div class="item">
                        <label>Nome</label>
                        <div class="value">{{ feedback.nome }}</div>
                    </div>

                    <div class="item">
                        <label>Profssão</label>
                        <div class="value">{{ feedback.profissao }}</div>
                    </div>

                    <div class="item">
                        <label>Mensagem</label>
                        <div class="value">{{ feedback.texto }}</div>
                    </div>

                    <FormFilePP
                        :label="'Imagem'"
                        :text1="textFile1"
                        :text2="textFile2"
                        :accept="'image/jpeg, image/jpg, image/png'"
                        :singleFile="true"
                        :previewImg="true"
                    />
                </div>

                <div v-if="emptyFeedbacks">
                    <h6>Não existem feedbacks.<br />Clique no botão "Adicionar feedback".</h6>
                </div>
            </div>

            <div class="footer-buttons">
                <hr class="line" />

                <b-button class="radius-6 submit" :variant="'primary'" @click="openFeedbackModal(false)">
                    Adicionar feedback
                </b-button>
            </div>
        </b-form>

        <b-modal
            ref="add-feedback-modal-ref"
            title="Enviar feedback"
            size="lg"
            cancel-title="Cancelar"
            :ok-title="isUpdate ? 'Atualizar' : 'Enviar'"
            ok-variant="primary"
            :modal-class="`alter-profile-modal ${getIsDarkTheme ? 'dark-theme' : ''}`"
            :no-close-on-backdrop="true"
            :clickToClose="false"
            :no-close-on-esc="true"
            @ok="saveFeedback"
        >
            <b-form @submit.stop.prevent="onSubmit" novalidate>
                <div class="feedback">
                    <b-form-group label="Nome" :label-for="`name`" class="required">
                        <b-form-input
                            :name="'name'"
                            v-model="$v.addSFeedbackForm.name.$model"
                            placeholder="Digite aqui."
                            :state="validateState('name')"
                        ></b-form-input>

                        <b-form-invalid-feedback :state="validateState('name')">
                            Campo obrigatório
                        </b-form-invalid-feedback>
                    </b-form-group>

                    <b-form-group label="Profssão" label-for="profession" class="required">
                        <b-form-input
                            id="profession"
                            name="profession"
                            v-model="$v.addSFeedbackForm.profession.$model"
                            placeholder="Digite aqui."
                            :state="validateState('profession')"
                        ></b-form-input>

                        <b-form-invalid-feedback :state="validateState('profession')">
                            Campo obrigatório
                        </b-form-invalid-feedback>
                    </b-form-group>

                    <b-form-group label="Mensagem" label-for="message" class="required">
                        <b-form-textarea
                            id="message"
                            name="message"
                            v-model="$v.addSFeedbackForm.message.$model"
                            placeholder="Descreva aqui."
                            rows="6"
                            :state="validateState('message')"
                        ></b-form-textarea>

                        <b-form-invalid-feedback :state="validateState('message')">
                            Campo obrigatório
                        </b-form-invalid-feedback>
                    </b-form-group>

                    <FormFilePP
                        :label="'Imagem'"
                        :text1="textFile1"
                        :text2="textFile2"
                        :accept="'image/jpeg, image/jpg, image/png'"
                        :singleFile="true"
                        :previewImg="true"
                    />
                </div>
            </b-form>
        </b-modal>

        <b-modal
            ref="feedback-success-modal-ref"
            :hide-header="true"
            :hide-footer="true"
            body-class="warning-modal"
            :modal-class="getIsDarkTheme ? 'dark-theme' : ''"
        >
            <div class="content">
                <SuccessMsgModal :msg="message" />
            </div>

            <div class="footer-buttons">
                <b-button variant="success" @click="hideModal('feedback-success-modal-ref')">Entendi</b-button>
            </div>
        </b-modal>

        <DangerModalPP ref="warningModal" :message="message" />
    </div>
</template>

<script>
import { mapActions } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import FormFilePP from '@/ui/form-file-pp/FormFilePP'
import FeedbackApi from '../../../../../api/admin/feedback-api/FeedbackApi'
import DangerModalPP from '@/ui/modal/danger-modal-pp/DangerModalPP'
import SuccessMsgModal from '@/ui/modal/success-msg-modal/SuccessMsgModal'

const feedbackApi = new FeedbackApi()

export default {
    name: 'EditPagesFeedbacksForm',
    components: { FormFilePP, DangerModalPP, SuccessMsgModal },
    data() {
        return {
            message: null,
            warningMessage: 'Tem certeza que deseja excluir o apoiador do site?',
            isUpdate: false,
            emptyFeedbacks: false,
            form: {
                feedbacks: []
            },
            addSFeedbackForm: {
                name: null,
                profession: null,
                message: null,
                file: null
            },
            textFile1: 'Tamanho de upload de imagem para 2 Mb',
            textFile2: 'Arquivos suportados: .png. e, .jpg'
        }
    },
    validations: {
        addSFeedbackForm: {
            name: { required },
            profession: { required },
            message: { required }
        }
    },
    computed: {
        getIsDarkTheme() {
            return this.$store.state.darkTheme
        }
    },
    methods: {
        ...mapActions(['setIsLoading']),
        validateState(nameField) {
            const { $dirty, $error } = this.$v.addSFeedbackForm[nameField]
            return $dirty ? !$error : null
        },
        fetch() {
            this.setIsLoading(true)

            feedbackApi
                .getFeedback()
                .then(response => {
                    const data = response.data.result
                    this.form.feedbacks = data
                    this.emptyFeedbacks = data.length === 0
                })
                .catch(error => {
                    this.message = error.response.data.message
                    this.$refs.warningModal.showModal()
                })
                .finally(() => this.setIsLoading(false))
        },
        saveFeedback(event) {
            event.preventDefault()

            this.$v.addSFeedbackForm.$touch()
            if (this.$v.addSFeedbackForm.$anyError) {
                return
            }

            const data = {
                texto: this.addSFeedbackForm.message,
                nome: this.addSFeedbackForm.name,
                profissao: this.addSFeedbackForm.profession
            }

            if (this.isUpdate) {
                data.status = this.addSFeedbackForm.status
            }

            const request = this.isUpdate
                ? feedbackApi.updateFeedback(this.addSFeedbackForm.id, data)
                : feedbackApi.createFeedback(data)

            this.setIsLoading(true)

            request
                .then(response => {
                    this.hideModal('add-feedback-modal-ref')
                    this.requestSuccess(response)
                })
                .catch(error => {
                    this.message = error.response.data.message
                    this.$refs.warningModal.showModal()
                })
                .finally(() => this.setIsLoading(false))
        },
        deleteFeedback(userId) {
            this.setIsLoading(true)

            feedbackApi
                .deleteFeedback(userId)
                .then(response => {
                    this.requestSuccess(response)
                })
                .catch(error => {
                    this.message = error.response.data.message
                    this.$refs.warningModal.showModal()
                })
                .finally(() => this.setIsLoading(false))
        },
        requestSuccess(response) {
            this.message = response.data.message
            this.fetch()
            this.showModal('feedback-success-modal-ref')
        },
        openFeedbackModal(isUpdate, data) {
            this.$v.addSFeedbackForm.$reset()
            this.isUpdate = isUpdate

            if (isUpdate) {
                this.addSFeedbackForm.id = data.id
                this.addSFeedbackForm.message = data.texto
                this.addSFeedbackForm.name = data.nome
                this.addSFeedbackForm.profession = data.profissao
                this.addSFeedbackForm.status = data.status
            } else {
                this.addSFeedbackForm.message = null
                this.addSFeedbackForm.name = null
                this.addSFeedbackForm.profession = null
            }
            this.showModal('add-feedback-modal-ref')
        },
        showModal(refModalName) {
            this.$refs[refModalName].show()
        },
        hideModal(refModalName) {
            this.$refs[refModalName].hide()
        }
    },
    created() {
        this.fetch()
    }
}
</script>

<style scope src="./EditPagesFeedbacksForm-light-theme.css"></style>
<style scope src="./EditPagesFeedbacksForm-dark-theme.css"></style>



// WEBPACK FOOTER //
// src/pages/private/dashboard-admin-grid-page/edit-pages-admin/edit-pages-feedbacks-form/EditPagesFeedbacksForm.vue